module.exports = __webpack_public_path__ + "rs.c89987db93164be2d358.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/rs.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/rs.svg
// module chunks = styles